import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { BUILD_ID, BUILD_TIME } from '../../build-id';

/** Повідомляє бекенд, яка версія застосунку (нативна збірка + OTA-пакет) стоїть у користувача. */
@Injectable({ providedIn: 'root' })
export class AppInfoReportService {
  constructor(private http: HttpClient) {}

  async report(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    const info = await App.getInfo().catch(() => null);
    this.http.post('/api/user/app-info', {
      version: info ? `${info.version} (${info.build})` : null,
      platform: Capacitor.getPlatform(),
      buildId: BUILD_ID,
      buildTime: BUILD_TIME
    }).subscribe({ error: () => undefined });
  }
}
